import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "overlay"]
  static values = { open: Boolean }

  connect() {
    this.openValue = false
    this.sync()
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
  }

  hide(event) {
    if (this.mobileViewport()) {
      if (event && this.clickInsideNav(event.target)) return

      this.openValue = false
      return
    }

    this.hideDesktopMenus(event)
  }

  hideWithEscape(event) {
    if (event.key !== "Escape") return
    this.openValue = false
    this.closeDesktopMenus()
  }

  hideOnNavigate() {
    this.openValue = false
    this.closeDesktopMenus()
  }

  openValueChanged() {
    this.sync()
  }

  sync() {
    this.toggleVisible(this.menuTarget, this.openValue)
    this.toggleVisible(this.overlayTarget, this.openValue)
    this.overlayTarget.classList.toggle("opacity-0", !this.openValue)
    this.overlayTarget.classList.toggle("opacity-100", this.openValue)
  }

  toggleVisible(element, visible) {
    element.classList.toggle("hidden", !visible)
    element.classList.toggle("block", visible)
  }

  clickInsideNav(target) {
    return this.buttonTarget.contains(target) || this.menuTarget.contains(target)
  }

  hideDesktopMenus(event) {
    const openMenus = this.openDesktopMenus()
    if (openMenus.length === 0) return
    if (event && openMenus.some((menu) => menu.contains(event.target))) return

    this.closeDesktopMenus()
  }

  closeDesktopMenus() {
    this.openDesktopMenus().forEach((menu) => {
      menu.removeAttribute("open")
    })
  }

  openDesktopMenus() {
    return Array.from(this.element.querySelectorAll("details[open]"))
  }

  mobileViewport() {
    return window.matchMedia("(max-width: 1023px)").matches
  }
}
